// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3tNwC","description":"PatientConsentPreview_description__1EAcU"};